var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.selected_gebr,"items":_vm.filtered_users,"item-value":"code","item-text":"name","label":_vm.label,"dense":_vm.isDense,"clearable":_vm.isClearable},on:{"change":_vm.updateData}})
}
var staticRenderFns = []

export { render, staticRenderFns }